module.exports = __webpack_public_path__ + "static/media/deepaDograPortrait.a99b9ff0.jpg";